import Dialog from "components/dialog";
import Link from "next/link";

import clsx from "clsx";

import { useState } from "react";
import { useUser } from "hooks/user";

export default function Graph(props) {
  const { title, noPadding, className } = props;
  const { loading } = props;

  const { user } = useUser();
  const [showWarningDialog, setShowWarningDialog] = useState(false);

  return (
    <>
      <div
        className={clsx(
          "graph fade-loading md:border-b-none relative h-full border-b border-b-gray-100 md:rounded-lg md:shadow",
          className,
          {
            loading
          }
        )}
      >
        <header className="px-4 py-3 text-lg font-bold bg-gray-50 border-b border-b-primary-300">
          {title}
        </header>

        <div className={clsx({ "p-5": !noPadding })}>{props.children}</div>
      </div>

      {user === null && (
        <div className="flex justify-end w-full">
          <span
            onClick={() => setShowWarningDialog(true)}
            className="mt-2 mx-5 underline text-sm box-border cursor-pointer"
          >
            * Dados fictícios
          </span>
        </div>
      )}

      {showWarningDialog && (
        <Dialog
          title="Dados fictícios"
          confirmText="Entendi!"
          onCancel={() => setShowWarningDialog(false)}
        >
          <p className="dialog-text">
            Como você ainda não criou uma conta, os gráficos são baseados em
            dados de amostra, com o objetivo de ilustrar a utilidade da
            ferramenta.
          </p>

          <p className="dialog-text">
            <Link href="/cadastro">
              <a>Crie uma conta</a>
            </Link>{" "}
            gratuita para ver os gráficos com os seus dados reais!
          </p>
        </Dialog>
      )}
    </>
  );
}
